import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setDraftBailiffSearch } from "store/bailiff/draft/bailiff/draft_bailiff.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffSearch = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handleChange = (e) => {
    const value = e.target.value;
    dispatch(setDraftBailiffSearch(value));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Input
      onChange={handleChange}
      suffix={<SearchOutlined />}
      placeholder="Tìm kiếm bailiff"
      style={{ borderRadius: 10 }}
    />
  );
};
export default BailiffSearch;
